var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g7, _g8, _g9, _g10, _g11, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotTabletIlustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 446,
    viewBox: "0 0 439 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 247.724,
    y: 171.224,
    width: 16,
    height: 26,
    rx: 8,
    fill: "url(#paint0_linear_80_202)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 382.724,
    y: 171.224,
    width: 16,
    height: 26,
    rx: 8,
    fill: "url(#paint1_linear_80_202)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_80_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.558 129.724C310.926 102.068 337.524 102.715 384.89 129.724C432.256 156.733 216.19 157.38 263.558 129.724Z",
    fill: "url(#paint2_linear_80_202)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_80_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.724,
    y: 153.224,
    width: 135,
    height: 59,
    rx: 20,
    fill: "#3B457B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_80_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.724,
    y: 171.224,
    width: 100,
    height: 22,
    rx: 11,
    fill: "#F0F1F9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_80_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.724 178.224C292.41 178.224 289.724 181.806 289.724 186.224H301.724C301.724 181.806 299.037 178.224 295.724 178.224Z",
    fill: "#5F6CB4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_80_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.724 178.224C347.41 178.224 344.724 181.806 344.724 186.224H356.724C356.724 181.806 354.037 178.224 350.724 178.224Z",
    fill: "#5F6CB4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_80_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.724,
    y: 197.224,
    width: 7,
    height: 10,
    rx: 3.5,
    fill: "#F0F1F9"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 304.724,
    y: 222.224,
    width: 37,
    height: 14,
    fill: "#191E3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.674 220.724C331.604 229.493 315.842 229.288 287.773 220.724C259.704 212.16 387.744 211.955 359.674 220.724Z",
    fill: "url(#paint3_linear_80_202)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220.614,
    y: 299.357,
    width: 55.0923,
    height: 8.22273,
    rx: 4.11136,
    transform: "rotate(-33.433 220.614 299.357)",
    fill: "#191E3A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 224.813,
    y: 305.922,
    width: 24.4313,
    height: 8.22273,
    rx: 4.11136,
    transform: "rotate(-118.344 224.813 305.922)",
    fill: "#191E3A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 187.724,
    y: 250.69,
    width: 23.0236,
    height: 53.4477,
    rx: 11.5118,
    transform: "rotate(-27.037 187.724 250.69)",
    fill: "url(#paint4_linear_80_202)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 378.248,
    y: 272.849,
    width: 55.0923,
    height: 8.22273,
    rx: 4.11136,
    transform: "rotate(24.3239 378.248 272.849)",
    fill: "#191E3A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 411.639,
    y: 315.346,
    width: 24.4313,
    height: 8.22273,
    rx: 4.11136,
    transform: "rotate(-69.6014 411.639 315.346)",
    fill: "#191E3A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 408.266,
    y: 302.797,
    width: 23.0236,
    height: 53.4477,
    rx: 11.5118,
    transform: "rotate(20.3986 408.266 302.797)",
    fill: "url(#paint5_linear_80_202)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_80_202)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.224,
    cy: 428.724,
    r: 8.5,
    fill: "url(#paint6_linear_80_202)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_80_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.895 286.17H320.684V362.319H366.717C382.894 331.343 382.635 289.182 380.484 271.973C376.354 243.062 352.377 236.121 340.904 236.265H308.638C269.402 234.888 262.461 268.961 263.895 286.17Z",
    fill: "url(#paint7_linear_80_202)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_80_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.963 288.321H263.895C263.895 367.137 307.777 404.48 324.126 412.224C344.088 401.21 359.977 376.086 365.427 364.9H318.963V288.321Z",
    fill: "url(#paint8_linear_80_202)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_80_202)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 355.224,
    cy: 285.724,
    r: 8.5,
    fill: "#F0F1F9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_80_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.299 73.147C304.805 67.773 306.767 62.4084 310.079 58.3843C313.393 54.3576 318.016 51.724 322.801 51.724C327.586 51.724 332.175 54.354 335.473 58.3792C338.769 62.4018 340.732 67.769 340.303 73.153C340.049 76.3333 338.161 78.6769 336.22 80.9537C336.142 81.0446 336.065 81.1356 335.987 81.2266C335.106 82.2573 334.225 83.2883 333.552 84.3598C332.902 85.3955 332.426 86.4992 332.322 87.724H314.238C314.033 86.6082 313.452 85.5732 312.716 84.5839C312.039 83.6747 311.2 82.7628 310.348 81.8376C310.151 81.6232 309.953 81.4081 309.756 81.1921C307.63 78.8594 305.596 76.3692 305.299 73.147Z",
    stroke: "#3B457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.301 99.224C328.548 99.224 332.801 94.2991 332.801 88.224H313.801C313.801 94.2991 318.055 99.224 323.301 99.224Z",
    fill: "#3B457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.301 68.724V87.724",
    stroke: "#3B457B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.301,
    cy: 65.724,
    r: 3,
    stroke: "#3B457B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.301 91.224H332.301",
    stroke: "#3B457B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.296 161.712C184.879 152.727 225.522 188.064 242.187 206.91C202.385 156.335 185.95 124.584 182.289 114.009C182.088 113.43 182.201 112.781 182.537 112.269C199.181 86.9027 175.67 64.889 160.705 56.3446C160.026 55.9568 159.63 55.1986 159.656 54.417C160.747 22.2194 120.131 22.375 98.692 26.6603C98.1915 26.7604 97.6738 26.6592 97.2328 26.402C73.3929 12.4959 50.523 36.6259 41.6103 51.1241C41.3647 51.5237 40.9791 51.8242 40.5378 51.9832C8.42878 63.5526 17.5358 88.4924 26.8547 100.628C27.3695 101.298 27.42 102.239 27.0146 102.98C11.5816 131.217 54.5228 146.001 78.8819 150.026C79.3128 150.097 79.7041 150.311 80.0086 150.624C108.058 179.443 141.383 170.277 154.831 161.924C154.978 161.832 155.13 161.762 155.296 161.712Z",
    stroke: "#3B457B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.724 113.224H45.7236V115.224H168.724V113.224Z",
    fill: "#3B457B",
    mask: "url(#path-27-inside-1_80_202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3742 101.224H56.0816L59.8202 91.0422H61.0929L64.8316 101.224H63.5389L60.4963 92.653H60.4168L57.3742 101.224ZM57.8514 97.2467H63.0617V98.3405H57.8514V97.2467ZM67.4317 96.6302V101.224H66.2584V93.5876H67.3919V94.7808H67.4914C67.6703 94.393 67.9421 94.0815 68.3067 93.8462C68.6713 93.6075 69.1419 93.4882 69.7186 93.4882C70.2357 93.4882 70.6881 93.5943 71.0759 93.8064C71.4637 94.0152 71.7653 94.3334 71.9807 94.7609C72.1961 95.1852 72.3039 95.7221 72.3039 96.3717V101.224H71.1306V96.4513C71.1306 95.8514 70.9748 95.384 70.6632 95.0493C70.3517 94.7112 69.9241 94.5422 69.3806 94.5422C69.006 94.5422 68.6713 94.6234 68.3763 94.7858C68.0846 94.9482 67.8543 95.1852 67.6853 95.4967C67.5162 95.8083 67.4317 96.1861 67.4317 96.6302ZM74.9301 104.088C74.7312 104.088 74.5539 104.071 74.3981 104.038C74.2424 104.008 74.1346 103.978 74.075 103.948L74.3733 102.914C74.6583 102.987 74.9102 103.014 75.129 102.994C75.3477 102.974 75.5416 102.876 75.7106 102.701C75.883 102.528 76.0404 102.248 76.1829 101.86L76.4017 101.264L73.5778 93.5876H74.8506L76.9585 99.6729H77.0381L79.146 93.5876H80.4187L77.1773 102.338C77.0314 102.732 76.8508 103.059 76.6354 103.317C76.4199 103.579 76.1697 103.773 75.8846 103.899C75.6029 104.025 75.2847 104.088 74.9301 104.088ZM89.7628 98.0422H91.1151L92.2486 99.5337L92.5469 99.9314L94.2373 102.179H92.885L91.7714 100.687L91.493 100.309L89.7628 98.0422ZM94.6549 96.1331C94.6549 97.207 94.461 98.135 94.0732 98.9172C93.6854 99.6994 93.1535 100.303 92.4773 100.727C91.8012 101.151 91.0289 101.363 90.1606 101.363C89.2922 101.363 88.5199 101.151 87.8438 100.727C87.1677 100.303 86.6357 99.6994 86.2479 98.9172C85.8601 98.135 85.6663 97.207 85.6663 96.1331C85.6663 95.0592 85.8601 94.1312 86.2479 93.349C86.6357 92.5668 87.1677 91.9636 87.8438 91.5393C88.5199 91.1151 89.2922 90.903 90.1606 90.903C91.0289 90.903 91.8012 91.1151 92.4773 91.5393C93.1535 91.9636 93.6854 92.5668 94.0732 93.349C94.461 94.1312 94.6549 95.0592 94.6549 96.1331ZM93.4617 96.1331C93.4617 95.2515 93.3142 94.5074 93.0192 93.9008C92.7276 93.2943 92.3315 92.8353 91.831 92.5237C91.3339 92.2122 90.777 92.0564 90.1606 92.0564C89.5441 92.0564 88.9856 92.2122 88.4851 92.5237C87.988 92.8353 87.5919 93.2943 87.2969 93.9008C87.0053 94.5074 86.8594 95.2515 86.8594 96.1331C86.8594 97.0147 87.0053 97.7588 87.2969 98.3653C87.5919 98.9719 87.988 99.4309 88.4851 99.7425C88.9856 100.054 89.5441 100.21 90.1606 100.21C90.777 100.21 91.3339 100.054 91.831 99.7425C92.3315 99.4309 92.7276 98.9719 93.0192 98.3653C93.3142 97.7588 93.4617 97.0147 93.4617 96.1331ZM101.381 98.1018V93.5876H102.555V101.224H101.381V99.9314H101.302C101.123 100.319 100.845 100.649 100.467 100.921C100.089 101.189 99.6116 101.323 99.0349 101.323C98.5576 101.323 98.1333 101.219 97.7621 101.01C97.3909 100.798 97.0993 100.48 96.8871 100.056C96.675 99.6281 96.569 99.0895 96.569 98.4399V93.5876H97.7422V98.3604C97.7422 98.9172 97.898 99.3613 98.2096 99.6927C98.5244 100.024 98.9255 100.19 99.4127 100.19C99.7044 100.19 100.001 100.115 100.303 99.9662C100.608 99.817 100.863 99.5883 101.068 99.2801C101.277 98.9719 101.381 98.5791 101.381 98.1018ZM107.905 101.383C107.17 101.383 106.535 101.221 106.001 100.896C105.471 100.568 105.062 100.11 104.773 99.5237C104.488 98.9338 104.346 98.2477 104.346 97.4655C104.346 96.6833 104.488 95.9939 104.773 95.3973C105.062 94.7974 105.463 94.3301 105.976 93.9953C106.493 93.6572 107.097 93.4882 107.786 93.4882C108.184 93.4882 108.577 93.5545 108.964 93.6871C109.352 93.8196 109.705 94.0351 110.023 94.3334C110.342 94.6284 110.595 95.0195 110.784 95.5067C110.973 95.9939 111.067 96.5938 111.067 97.3064V97.8035H105.181V96.7893H109.874C109.874 96.3585 109.788 95.974 109.616 95.6359C109.447 95.2979 109.205 95.0311 108.89 94.8355C108.578 94.64 108.21 94.5422 107.786 94.5422C107.319 94.5422 106.914 94.6582 106.573 94.8902C106.235 95.1189 105.975 95.4172 105.792 95.7851C105.61 96.153 105.519 96.5474 105.519 96.9683V97.6445C105.519 98.2212 105.618 98.71 105.817 99.1111C106.02 99.5088 106.3 99.8121 106.658 100.021C107.016 100.226 107.431 100.329 107.905 100.329C108.214 100.329 108.492 100.286 108.741 100.2C108.993 100.11 109.21 99.9778 109.392 99.8021C109.574 99.6231 109.715 99.4011 109.815 99.1359L110.948 99.4541C110.829 99.8386 110.628 100.177 110.346 100.468C110.065 100.757 109.717 100.982 109.302 101.144C108.888 101.304 108.422 101.383 107.905 101.383ZM118.261 95.2979L117.207 95.5962C117.141 95.4205 117.043 95.2498 116.914 95.0841C116.788 94.915 116.616 94.7758 116.397 94.6665C116.178 94.5571 115.898 94.5024 115.557 94.5024C115.089 94.5024 114.7 94.6101 114.388 94.8256C114.08 95.0377 113.926 95.3078 113.926 95.6359C113.926 95.9276 114.032 96.1579 114.244 96.327C114.456 96.496 114.788 96.6369 115.239 96.7496L116.372 97.028C117.055 97.1937 117.564 97.4472 117.898 97.7886C118.233 98.1267 118.4 98.5625 118.4 99.0962C118.4 99.5337 118.275 99.9248 118.023 100.269C117.774 100.614 117.426 100.886 116.979 101.085C116.531 101.284 116.011 101.383 115.417 101.383C114.639 101.383 113.994 101.214 113.484 100.876C112.973 100.538 112.65 100.044 112.514 99.3945L113.628 99.116C113.734 99.527 113.934 99.8353 114.229 100.041C114.528 100.246 114.917 100.349 115.398 100.349C115.944 100.349 116.379 100.233 116.7 100.001C117.025 99.7657 117.187 99.4839 117.187 99.1558C117.187 98.8907 117.095 98.6686 116.909 98.4896C116.723 98.3073 116.438 98.1714 116.054 98.082L114.781 97.7837C114.082 97.6179 113.568 97.3611 113.24 97.0131C112.915 96.6617 112.753 96.2226 112.753 95.6956C112.753 95.2647 112.874 94.8836 113.116 94.5521C113.361 94.2207 113.694 93.9605 114.115 93.7716C114.539 93.5827 115.02 93.4882 115.557 93.4882C116.312 93.4882 116.906 93.6539 117.337 93.9854C117.771 94.3168 118.079 94.7543 118.261 95.2979ZM123.488 93.5876V94.582H119.53V93.5876H123.488ZM120.684 91.7581H121.857V99.0365C121.857 99.3679 121.905 99.6165 122.001 99.7822C122.101 99.9446 122.227 100.054 122.379 100.11C122.535 100.163 122.699 100.19 122.871 100.19C123 100.19 123.106 100.183 123.189 100.17C123.272 100.153 123.338 100.14 123.388 100.13L123.627 101.184C123.547 101.214 123.436 101.244 123.294 101.274C123.151 101.307 122.971 101.323 122.752 101.323C122.42 101.323 122.096 101.252 121.777 101.11C121.463 100.967 121.201 100.75 120.992 100.458C120.786 100.167 120.684 99.7988 120.684 99.3547V91.7581ZM125.253 101.224V93.5876H126.426V101.224H125.253ZM125.849 92.3149C125.62 92.3149 125.423 92.237 125.258 92.0812C125.095 91.9255 125.014 91.7382 125.014 91.5195C125.014 91.3007 125.095 91.1134 125.258 90.9577C125.423 90.8019 125.62 90.724 125.849 90.724C126.078 90.724 126.273 90.8019 126.436 90.9577C126.602 91.1134 126.684 91.3007 126.684 91.5195C126.684 91.7382 126.602 91.9255 126.436 92.0812C126.273 92.237 126.078 92.3149 125.849 92.3149ZM131.677 101.383C130.988 101.383 130.383 101.219 129.862 100.891C129.345 100.563 128.941 100.104 128.649 99.5138C128.361 98.9238 128.217 98.2344 128.217 97.4456C128.217 96.6501 128.361 95.9558 128.649 95.3625C128.941 94.7692 129.345 94.3085 129.862 93.9804C130.383 93.6523 130.988 93.4882 131.677 93.4882C132.366 93.4882 132.97 93.6523 133.487 93.9804C134.007 94.3085 134.411 94.7692 134.7 95.3625C134.991 95.9558 135.137 96.6501 135.137 97.4456C135.137 98.2344 134.991 98.9238 134.7 99.5138C134.411 100.104 134.007 100.563 133.487 100.891C132.97 101.219 132.366 101.383 131.677 101.383ZM131.677 100.329C132.201 100.329 132.632 100.195 132.97 99.9264C133.308 99.6579 133.558 99.305 133.72 98.8675C133.883 98.43 133.964 97.956 133.964 97.4456C133.964 96.9352 133.883 96.4596 133.72 96.0187C133.558 95.5779 133.308 95.2216 132.97 94.9499C132.632 94.6781 132.201 94.5422 131.677 94.5422C131.153 94.5422 130.723 94.6781 130.384 94.9499C130.046 95.2216 129.796 95.5779 129.634 96.0187C129.471 96.4596 129.39 96.9352 129.39 97.4456C129.39 97.956 129.471 98.43 129.634 98.8675C129.796 99.305 130.046 99.6579 130.384 99.9264C130.723 100.195 131.153 100.329 131.677 100.329ZM138.102 96.6302V101.224H136.928V93.5876H138.062V94.7808H138.161C138.34 94.393 138.612 94.0815 138.977 93.8462C139.341 93.6075 139.812 93.4882 140.389 93.4882C140.906 93.4882 141.358 93.5943 141.746 93.8064C142.134 94.0152 142.435 94.3334 142.651 94.7609C142.866 95.1852 142.974 95.7221 142.974 96.3717V101.224H141.8V96.4513C141.8 95.8514 141.645 95.384 141.333 95.0493C141.022 94.7112 140.594 94.5422 140.05 94.5422C139.676 94.5422 139.341 94.6234 139.046 94.7858C138.755 94.9482 138.524 95.1852 138.355 95.4967C138.186 95.8083 138.102 96.1861 138.102 96.6302ZM150.527 95.2979L149.473 95.5962C149.407 95.4205 149.309 95.2498 149.18 95.0841C149.054 94.915 148.881 94.7758 148.663 94.6665C148.444 94.5571 148.164 94.5024 147.822 94.5024C147.355 94.5024 146.966 94.6101 146.654 94.8256C146.346 95.0377 146.192 95.3078 146.192 95.6359C146.192 95.9276 146.298 96.1579 146.51 96.327C146.722 96.496 147.053 96.6369 147.504 96.7496L148.638 97.028C149.32 97.1937 149.829 97.4472 150.164 97.7886C150.499 98.1267 150.666 98.5625 150.666 99.0962C150.666 99.5337 150.54 99.9248 150.288 100.269C150.04 100.614 149.692 100.886 149.244 101.085C148.797 101.284 148.276 101.383 147.683 101.383C146.904 101.383 146.26 101.214 145.749 100.876C145.239 100.538 144.916 100.044 144.78 99.3945L145.893 99.116C145.999 99.527 146.2 99.8353 146.495 100.041C146.793 100.246 147.183 100.349 147.663 100.349C148.21 100.349 148.644 100.233 148.966 100.001C149.291 99.7657 149.453 99.4839 149.453 99.1558C149.453 98.8907 149.36 98.6686 149.175 98.4896C148.989 98.3073 148.704 98.1714 148.319 98.082L147.047 97.7837C146.347 97.6179 145.834 97.3611 145.506 97.0131C145.181 96.6617 145.018 96.2226 145.018 95.6956C145.018 95.2647 145.139 94.8836 145.381 94.5521C145.627 94.2207 145.96 93.9605 146.381 93.7716C146.805 93.5827 147.285 93.4882 147.822 93.4882C148.578 93.4882 149.171 93.6539 149.602 93.9854C150.036 94.3168 150.345 94.7543 150.527 95.2979ZM153.963 98.3604V98.3007C153.97 97.6677 154.036 97.1639 154.162 96.7893C154.288 96.4148 154.467 96.1115 154.699 95.8795C154.931 95.6475 155.21 95.4338 155.535 95.2382C155.73 95.1189 155.906 94.978 156.061 94.8156C156.217 94.6499 156.34 94.4593 156.429 94.2439C156.522 94.0284 156.569 93.7898 156.569 93.528C156.569 93.2032 156.492 92.9214 156.34 92.6828C156.187 92.4442 155.984 92.2602 155.728 92.131C155.473 92.0017 155.19 91.9371 154.878 91.9371C154.606 91.9371 154.345 91.9934 154.093 92.1061C153.841 92.2188 153.63 92.3961 153.461 92.6381C153.292 92.88 153.195 93.1965 153.168 93.5876H151.915C151.942 93.0242 152.088 92.5419 152.353 92.1409C152.621 91.7399 152.974 91.4333 153.412 91.2212C153.852 91.009 154.341 90.903 154.878 90.903C155.462 90.903 155.969 91.019 156.4 91.251C156.834 91.483 157.169 91.8012 157.404 92.2055C157.642 92.6099 157.762 93.0706 157.762 93.5876C157.762 93.9522 157.705 94.282 157.593 94.577C157.483 94.872 157.324 95.1355 157.115 95.3675C156.91 95.5995 156.661 95.805 156.37 95.9839C156.078 96.1662 155.844 96.3585 155.669 96.5606C155.493 96.7595 155.365 96.9965 155.286 97.2716C155.206 97.5467 155.163 97.8897 155.157 98.3007V98.3604H153.963ZM154.6 101.304C154.355 101.304 154.144 101.216 153.968 101.04C153.793 100.864 153.705 100.654 153.705 100.409C153.705 100.163 153.793 99.9529 153.968 99.7773C154.144 99.6016 154.355 99.5138 154.6 99.5138C154.845 99.5138 155.056 99.6016 155.231 99.7773C155.407 99.9529 155.495 100.163 155.495 100.409C155.495 100.571 155.453 100.72 155.37 100.856C155.291 100.992 155.183 101.101 155.047 101.184C154.915 101.264 154.766 101.304 154.6 101.304Z",
    fill: "#3B457B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_80_202",
    x: 252.724,
    y: 109.224,
    width: 143,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_80_202",
    x: 251.724,
    y: 153.224,
    width: 143,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_80_202",
    x: 273.724,
    y: 171.224,
    width: 100,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_80_202"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_80_202",
    x: 285.724,
    y: 178.224,
    width: 20,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_80_202",
    x: 340.724,
    y: 178.224,
    width: 20,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_80_202",
    x: 321.724,
    y: 197.224,
    width: 7,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_80_202"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_80_202",
    x: 310.724,
    y: 420.224,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_80_202",
    x: 259.724,
    y: 236.224,
    width: 125.803,
    height: 134.095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.152941 0 0 0 0 0.286275 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_80_202",
    x: 259.895,
    y: 288.321,
    width: 109.532,
    height: 131.903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.188235 0 0 0 0 0.345098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_80_202",
    x: 346.724,
    y: 277.224,
    width: 17,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_80_202"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_80_202",
    x: 300.724,
    y: 51.224,
    width: 44.138,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.270588 0 0 0 0 0.482353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_202",
    x1: 255.724,
    y1: 171.224,
    x2: 255.724,
    y2: 197.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#5F6CB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_80_202",
    x1: 390.724,
    y1: 171.224,
    x2: 390.724,
    y2: 197.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#5F6CB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_80_202",
    x1: 324.224,
    y1: 109.224,
    x2: 324.224,
    y2: 150.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#6E7BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_80_202",
    x1: 323.724,
    y1: 227.224,
    x2: 323.724,
    y2: 214.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#313756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_80_202",
    x1: 199.235,
    y1: 250.69,
    x2: 199.235,
    y2: 304.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#5F6CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_80_202",
    x1: 419.777,
    y1: 302.797,
    x2: 419.777,
    y2: 356.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#5F6CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4ABD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_80_202",
    x1: 323.224,
    y1: 420.224,
    x2: 323.224,
    y2: 437.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_80_202",
    x1: 322.625,
    y1: 236.224,
    x2: 322.625,
    y2: 362.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F6CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3B457B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_80_202",
    x1: 314.661,
    y1: 288.321,
    x2: 314.661,
    y2: 412.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#3B457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotTabletIlustration);
export default __webpack_public_path__ + "static/media/robot_tablet_ilustration.fa0d05381f716a4e0bc70455ecfc58ef.svg";
export { ForwardRef as ReactComponent };